"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarYear = void 0;
var CalendarYear_styles_1 = require("./CalendarYear.styles");
var Utilities_1 = require("../../../Utilities");
var CalendarYear_base_1 = require("./CalendarYear.base");
exports.CalendarYear = Utilities_1.styled(CalendarYear_base_1.CalendarYearBase, CalendarYear_styles_1.getStyles, undefined, { scope: 'CalendarYear' });
//# sourceMappingURL=CalendarYear.js.map